import React from 'react'

const ModalSecond = () => {
  return (
   <div className="modal fade" id="eventsModal2" tabindex="-1" aria-labelledby="eventsModalLabel2" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="eventsModalLabel2">Additional Information</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <h3>Sunday Sept 6 - Duck Race at the Pool</h3>
          <p>Ready, set... quack! Purchase your lucky racing duck for just $1.00 each and cheer it on as it races to the finish.</p>
          <p>🦆Duck Sales Begin: Saturday at 10:00 AM</p>
          <p>Cost: $1.00 per duck</p>
          <p>Where to Buy: Lot 41</p>
          <p>Will your duck be the first to cross the finish line? There's only one way to find out!</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ModalSecond